export const EMPTY_ACCOUNT_FORM = {
  companyName: "",
  industry: "",
  website: "",
  city: "",
  state: "",
  potentialAcv: "",
  owner: "",
  stage: "",
  talkingTo: "",
  designation: "",
  keyStakeholders: "",
  leadStatus: "",
  assetType: "",
  ecosystemRole: "",
  lastTouchPoint: "",
  nextAction: "",
  expectedClose: "",
  solutionRequired: "",
  discussionComments: "",
  status: "lead",
  tier: "standard",
  fleetSize: "",
  mrr: "",
  internalNotes: "",
  contactName: "",
  contactRole: "",
  contactEmail: "",
  contactPhone: "",
};

export function accountToForm(account) {
  if (!account) return { ...EMPTY_ACCOUNT_FORM };
  const sp = account.salesPipeline ?? {};
  return {
    companyName: account.companyName ?? "",
    industry: account.industry ?? "",
    website: account.website ?? "",
    city: account.city ?? "",
    state: account.state ?? "",
    potentialAcv: sp.potentialAcv ?? "",
    owner: sp.owner ?? "",
    stage: sp.stage ?? "",
    talkingTo: sp.talkingTo ?? "",
    designation: sp.designation ?? "",
    keyStakeholders: sp.keyStakeholders ?? "",
    leadStatus: sp.leadStatus ?? "",
    assetType: sp.assetType ?? "",
    ecosystemRole: sp.ecosystemRole ?? "",
    lastTouchPoint: sp.lastTouchPoint ?? "",
    nextAction: sp.nextAction ?? "",
    expectedClose: sp.expectedClose ?? "",
    solutionRequired: sp.solutionRequired ?? "",
    discussionComments: sp.discussionComments ?? "",
    status: account.status ?? "lead",
    tier: account.tier ?? "standard",
    fleetSize: account.fleetSize != null ? String(account.fleetSize) : "",
    mrr: account.mrr != null ? String(account.mrr) : "",
    internalNotes: account.internalNotes ?? account.notes ?? "",
    contactName: account.contact?.name ?? "",
    contactRole: account.contact?.role ?? "",
    contactEmail: account.contact?.email ?? "",
    contactPhone: account.contact?.phone ?? "",
  };
}

export function formToAccountPayload(form, existing = null) {
  const now = new Date().toISOString().slice(0, 10);
  const contactFilled = [form.contactName, form.contactEmail, form.contactPhone, form.contactRole].some((v) => v?.trim());
  return {
    id: existing?.id ?? `acc-${Date.now()}`,
    companyName: form.companyName.trim(),
    industry: form.industry.trim(),
    website: form.website.trim(),
    city: form.city.trim(),
    state: form.state.trim(),
    salesPipeline: {
      potentialAcv: form.potentialAcv.trim(),
      owner: form.owner,
      stage: form.stage,
      talkingTo: form.talkingTo.trim(),
      designation: form.designation.trim(),
      keyStakeholders: form.keyStakeholders.trim(),
      leadStatus: form.leadStatus,
      assetType: form.assetType.trim(),
      ecosystemRole: form.ecosystemRole.trim(),
      lastTouchPoint: form.lastTouchPoint.trim(),
      nextAction: form.nextAction.trim(),
      expectedClose: form.expectedClose.trim(),
      solutionRequired: form.solutionRequired.trim(),
      discussionComments: form.discussionComments.trim(),
    },
    status: form.status || "lead",
    tier: form.tier || "standard",
    fleetSize: Number(form.fleetSize) || 0,
    mrr: Number(form.mrr) || 0,
    internalNotes: form.internalNotes.trim(),
    contact: contactFilled
      ? {
          name: form.contactName.trim(),
          role: form.contactRole.trim(),
          email: form.contactEmail.trim(),
          phone: form.contactPhone.trim(),
        }
      : null,
    createdAt: existing?.createdAt ?? now,
    updatedAt: now,
  };
}

export function validateAccountForm(form) {
  return validateAccountStep(form, 1);
}

export function validateAccountStep(form, step) {
  const errors = {};
  if (step === 1 && !form.companyName?.trim()) {
    errors.companyName = "Company name is required";
  }
  return errors;
}

export const STEP_SUBTITLES = {
  1: "Step 1 — Company information",
  2: "Step 2 — Account & sales pipeline",
  3: "Step 3 — Primary contact",
};
